import * as React from "react";
import {
    Grid,
    MenuItem,
    SelectChangeEvent,
    TextField
} from "@mui/material";

type Props = {
    AllLists: any;
    plotQueryProps: any;
    setPlotQueryProps: React.Dispatch<React.SetStateAction<any>>;
    filterConfigList: any;
}
export default function PlotFilterList(props: Props) {
    const { AllLists, plotQueryProps, setPlotQueryProps, filterConfigList } = props
    return (
        filterConfigList.map((item, index) => {
            return (
                // eslint-disable-next-line react/jsx-key
                <Grid key={index} item xs={1}>
                    <TextField
                        key={index}
                        label={item.name}
                        name={item.propID}
                        onChange={(e) => {
                            let result
                            if (typeof e.target.value === 'object') {
                                if (plotQueryProps[e.target.name].indexOf(item.defaultValue) < 0) {
                                    // @ts-ignore
                                    if (e.target.value.indexOf(item.defaultValue) >= 0) {
                                        result = [item.defaultValue]
                                    }
                                } else {
                                    // @ts-ignore
                                    result = e.target.value.filter(i => i != item.defaultValue)
                                }
                            }
                            setPlotQueryProps({ ...plotQueryProps, [e.target.name]: result ?? e.target.value })
                        }
                        }
                        select
                        required
                        fullWidth
                        value={plotQueryProps[item.propID]}
                        variant="filled"
                        defaultValue={item.defaultValue}
                        size="small"
                        SelectProps={{ multiple: item.multiple }}
                    >
                        <MenuItem key={"ALL"} value={item.defaultValue}>
                            {"ALL"}
                        </MenuItem>
                        {updateFilter(AllLists, item, plotQueryProps)?.map((option) => (
                            <MenuItem key={option[item.valueKey]} value={option[item.valueKey]}>
                                {option[item.valueName]}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
            );
        })
    )
}

function updateFilter(AllList, filterConfigItem, plotQueryProps) {
    switch (filterConfigItem.listName) {
        case 'executeGetLocationList':
            if (plotQueryProps["inState"] == 'ALL') {
                return AllList?.[filterConfigItem.listName]
            } else {
                return AllList?.[filterConfigItem.listName].filter(item => item.State == plotQueryProps["inState"])
            }
        default:
            return AllList?.[filterConfigItem.listName]
    }
}
